export const TYPES = {
  SET_DRAFT_DIALOG_EDITED: "draft_dialog/SET_DRAFT_DIALOG_EDITED",
};
